import React, { useEffect,useState } from "react";
import { useLocation } from "react-router-dom";

// --- ASSETS ---
import Laothan_lcm from "./image/lcm_tour/laothan.jpg";
import kyquansan from "./image/lcm_tour/kyquansan.jpg";
import back from "./image/lcm_tour/back_m.png"; 
import Samu from "./image/lcm_tour/samu.jpg";
import lungcung_w from "./image/lcm_tour/lungcung_w.png";

// Component BenefitSection tối ưu cho Mobile
const BenefitSection = ({ title, children, img, isReverse = false }) => (
  <div className={`flex flex-col ${isReverse ? 'md:flex-row-reverse' : 'md:flex-row'} 
    items-stretch gap-0 my-8 md:my-12 overflow-hidden rounded-[30px] md:rounded-[40px] shadow-2xl bg-white 
    border-4 border-white w-full mx-auto`}>
    
    {/* KHỐI ẢNH: Luôn vuông trên mọi thiết bị */}
    <div className="w-full md:w-1/2 aspect-square relative overflow-hidden flex-shrink-0">
      <img 
        src={img} 
        className="absolute inset-0 w-full h-full object-cover" 
        alt="Hành trình" 
      />
    </div>
    
    {/* KHỐI NỘI DUNG: Padding nhỏ hơn trên Mobile */}
    <div className="w-full md:w-1/2 p-8 md:p-16 flex flex-col justify-center bg-slate-50">
      {title && (
        <h2 className="text-2xl md:text-5xl font-black text-sky-600 mb-4 md:mb-6 uppercase tracking-tighter leading-none">
          {title}
        </h2>
      )}
      <div className="text-base md:text-xl text-slate-700 leading-relaxed font-medium italic">
        {children}
      </div>
    </div>
  </div>
);

const ProductBillboard = ({ title, img, features, isReverse = false }) => (
  <div className={`flex flex-col ${isReverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-stretch gap-0 my-8 md:my-10 overflow-hidden rounded-[30px] md:rounded-[40px] shadow-2xl bg-white border-4 border-white`}>
    <div className="w-full md:w-1/2 aspect-square md:min-h-[300px] relative">
      <img src={img} className="absolute inset-0 w-full h-full object-cover" alt="Tour Feature" />
    </div>
    <div className="w-full md:w-1/2 p-8 md:p-14 flex flex-col justify-center bg-slate-50">
      <h2 className="text-2xl md:text-5xl font-black text-sky-600 mb-2 uppercase tracking-tighter leading-none">
        {title}
      </h2>
      <div className="text-base md:text-xl text-slate-700 leading-relaxed font-medium italic mb-4 md:mb-6 ">
        Được ra đời từ đó là chuyến leo núi dành cho tất cả mọi người và chi phí 0 đồng để quảng bá, phát triển du lịch vùng núi cao
      </div>
      <ul className="space-y-3 md:space-y-4">
        {features.map((item, index) => (
          <li key={index} className="flex items-start gap-3 text-sm md:text-xl font-bold text-slate-700 italic">
            <span className="text-orange-500">▶</span> {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default function Lcm_tour_w() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [activeBenefit, setActiveBenefit] = useState(0);

const benefitCards = [
    { 
      title: "Hành trang nhẹ", 
      desc: "Xóa nỗi lo đau lưng vì mang vác nặng.", 
      borderColor: "border-sky-600", 
      textColor: "text-sky-600" 
    },
    { 
      title: "Thong dong", 
      desc: "Lịch trình dư dả thời gian để tự do đứng lại ngắm hoa, không vội vã di chuyển.", 
      borderColor: "border-orange-500", 
      textColor: "text-orange-500" 
    },
    { 
      title: "Quãng đường ngắn", 
      desc: "Tiết kiệm sức lực cho những hoạt động khám phá, vui chơi.", 
      borderColor: "border-slate-900", 
      textColor: "text-slate-900" 
    },
    { 
      title: "Chi phí 0 đồng", 
      desc: "Tour leo thuộc dự án xã hội phát triển du lịch nội địa. Hoàn toàn miễn phí dịch vụ", 
      borderColor: "border-green-600", 
      textColor: "text-green-600" 
    }
  ];

  return (
    <div className="relative min-h-screen font-sans overflow-x-hidden bg-slate-100"
         style={{ backgroundImage: `url(${back})`, backgroundAttachment: "fixed", backgroundSize: "cover" }}>
      
      <div className="absolute inset-0 bg-slate-900/40  backdrop-blur-[1px] z-0"></div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-10 mt-16 py-10 md:py-16">
        
        <header className="text-center mb-10">
          <h1 className="text-6xl font-black text-white mb-4 tracking-tighter uppercase leading-none drop-shadow-2xl">
            KEEP <span className="text-sky-400 italic font-serif">GOING</span>
          </h1>
          <p className="text-sm text-white/90 max-w-xs mx-auto font-medium italic leading-relaxed drop-shadow-md">
            "Hành trình thong dong đến đỉnh cao."
          </p>
        </header>
        {/* 4 CARD PHONG CÁCH WEBSITE: Nền trắng, viền trên có màu  */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 mb-24">
          {benefitCards.map((card, i) => (
            <div 
              key={i} 
              onClick={() => setActiveBenefit(activeBenefit === i ? null : i)}
              className={`bg-white aspect-square rounded-[30px] p-5 md:p-8 flex flex-col justify-center items-center text-center cursor-pointer transition-all duration-300 shadow-xl border-t-[8px] ${card.borderColor} 
              ${activeBenefit === i ? 'scale-105 z-10 ' : 'scale-100 opacity-95'}`}
            >
              <h3 className={`${card.textColor} font-black uppercase leading-tight tracking-tighter transition-all duration-300 
                ${activeBenefit === i ? 'text-[13px] md:text-xs mb-2 opacity-60' : 'text-sm md:text-2xl'}`}>
                {card.title}
              </h3>
              
              <div className={`transition-all duration-500 ease-in-out ${activeBenefit === i ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0'}`}>
                <p className="text-slate-600 text-[10px] md:text-[13px] font-bold italic leading-tight">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-8 md:space-y-12">
          <BenefitSection title="Chào bạn!" img={lungcung_w}>
            CLB Leo núi Việt Nam hân hạnh được giới thiệu với bạn chuyến leo núi Keep Going, truyền thống và
             tự hào. Bắt nguồn từ năm 2020, chúng mình hiểu cảm giác lần đầu leo núi luôn thận trọng về sức khỏe.
          </BenefitSection>

                    {/* Ý TƯỞNG 3: TEXT TRONG ẢNH TRÊN MOBILE */}
          <div className="flex flex-col md:grid md:grid-cols-2 gap-0 md:gap-8 items-stretch my-8">
  
          {/* Khối chữ: Bo tròn góc dưới được điều chỉnh để khớp với ảnh */}
          <div className="bg-sky-600 text-white p-8 md:p-12 
            rounded-t-[35px] md:rounded-[40px] shadow-xl 
            flex flex-col justify-center z-10 relative">
            <p className="text-xl md:text-3xl font-bold leading-snug">
              Và những công việc hỗ trợ đoàn: mang vác balo, thức ăn, nấu ăn, xây những căn nhà gỗ
                ngủ nghỉ và đồng hành cùng thành viên đi cuối - chính là cơ hội việc làm cho đồng bào sống trên những mảnh đất hùng vĩ và khắc nghiệt.
            </p>
            {/* Một mũi tên nhỏ trỏ xuống ảnh chỉ xuất hiện trên Mobile */}
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-0 h-0 
              border-l-[15px] border-l-transparent 
              border-r-[15px] border-r-transparent 
              border-t-[15px] border-t-sky-600 md:hidden">
            </div>
          </div>

          {/* Khối ảnh: Có viền xanh ở đỉnh để nối với khối chữ bên trên */}
          <div className="overflow-hidden rounded-b-[35px] md:rounded-[40px] 
            border-4 border-white border-t-0 md:border-t-4 
            shadow-xl relative aspect-square md:aspect-auto">
            
            {/* Viền màu nối tiếp trên Mobile */}
            <div className="h-2 bg-sky-600 md:hidden w-full"></div>
            
            <img src={Laothan_lcm} className="w-full h-full object-cover" alt="Leo núi" />
          </div>
        </div>

          <ProductBillboard 
            title="KEEP GOING" 
            img={Samu}
            features={[
              `Không đau lưng, trùng gối, đồng hành tốp cuối từ việc tăng cường porter hỗ trợ đoàn`,
              `Đứng lại ngắm một nhành hoa rừng mà không lo lắng thời gian.`,
              `Hành trình leo ngắn hơn bằng cách tận dụng những chuyến xe ôm xuyên bản làng hoang sơ.`,
              `Đến homestay chân núi ngủ 1 đêm trước khi leo, ăn sáng tại bản thay vì ngủ trên xe, gấp gáp di chuyển`
            ]}
          />

          {/* CHI PHÍ & THÔNG TIN CHUNG */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-10 md:my-16">
            <div className="bg-white p-8 md:p-10 rounded-[30px] md:rounded-[40px] shadow-xl border-b-8 border-sky-600">
              <span className="text-3xl md:text-5xl mb-4 block text-sky-600 font-black">Chi phí</span>
              <h3 className="text-lg md:text-2xl font-black uppercase mb-2">Chia đều thành viên</h3>
              <p className="text-xs md:text-slate-600 font-bold italic">Minh bạch và công khai</p>
            </div>
            <div className="bg-slate-900 text-white p-8 md:p-10 rounded-[30px] md:rounded-[40px] shadow-xl border-b-8 border-orange-500">
              <span className="text-3xl md:text-5xl mb-4 block text-orange-500 font-black">Dẫn đoàn</span>
              <h3 className="text-lg md:text-2xl font-black uppercase mb-2">CLB Leo núi Việt Nam</h3>
              <p className="text-xs md:text-white/70 font-bold italic">Người bạn kinh nghiệm luôn sẵn lòng lắng nghe bạn.</p>
            </div>
            <div className="bg-sky-600 text-white p-8 md:p-10 rounded-[30px] md:rounded-[40px] shadow-xl border-b-8 border-white">
              <span className="text-3xl md:text-5xl mb-4 block text-white font-black">Số lượng</span>
              <h3 className="text-lg md:text-2xl font-black uppercase mb-2">06 chuyến/năm</h3>
              <p className="text-xs md:text-white/90 font-bold italic">Chuyến đi được tổ chức trong suốt mùa leo núi, bắt đầu từ tháng 
                09 năm trước đến tháng 05 năm sau</p>
            </div>
          </div>

          <BenefitSection title="" img={kyquansan}>
            <button 
              onClick={() => window.open("https://forms.gle/Z35nDAkv5e5MWAha6")}
              className="group w-full mb-6 bg-orange-500 hover:bg-slate-900 text-white p-6 rounded-[30px] shadow-2xl transition-all active:scale-95 border-b-8 border-orange-700"
            >
              <span className="text-2xl md:text-5xl font-black uppercase tracking-tighter block transition-all group-hover:tracking-widest italic">
                Đăng ký ngay 
              </span>
            </button>
            Vì bước chân đầu tiên luôn là bước chân quan trọng nhất. Leo núi đơn giản là bắt đầu và không bỏ cuộc. Chúng mình lo hậu cần khó nhất, để bạn chỉ cần tập trung vượt qua chính mình.
          </BenefitSection>
        </div>

        <footer className="mt-16 md:mt-24 text-slate-500 text-[8px] md:text-[10px] font-black tracking-[0.3em] md:tracking-[0.5em] uppercase text-center opacity-60">
          Keep Going Trek — Since 2020 — The Healing Sip 
        </footer>
      </div>
    </div>
  );
}